import { forwardRef } from 'react'
import Template, { LabelCappedCenter } from 'components/Commons/Inputs/Template'
import useTranslate from 'hooks/useTranslate'

import { Container, Left, Right, InputField } from './styled'

function TextInput(
  {
    className,
    label,
    labelComponent,
    name,
    error,
    placeholder: placeholderIntl,
    placeholderColor,
    isRequired,
    left,
    right,
    disabled,
    readOnly,
    autoComplete = 'off',
    dataTestId,
    size = 'default',
    hasRightSpace = true,
    textAlign,
    outerRightWidth = 0,
    innerLeftWidth = 0,
    layoutConfiguration,
    ...inputProps
  },
  ref,
) {
  const translate = useTranslate()
  const placeholder = translate(placeholderIntl)

  const hasError = error !== undefined

  return (
    <Template
      label={label}
      labelComponent={labelComponent}
      name={name}
      error={error}
      Wrapper={LabelCappedCenter}
      layoutConfiguration={layoutConfiguration}
      isRequired={isRequired}
      disabled={disabled || readOnly}
      className={className}
    >
      <Container size={size}>
        {left && (
          <Left.Container>
            <Left size={size} innerLeftWidth={innerLeftWidth}>
              {left}
            </Left>
          </Left.Container>
        )}
        {right && (
          <Right.Container>
            <Right size={size} hasRightSpace={hasRightSpace} outerRightWidth={outerRightWidth}>
              {right}
            </Right>
          </Right.Container>
        )}
        <InputField
          id={name}
          name={name}
          placeholder={placeholder}
          placeholderColor={placeholderColor}
          hasError={hasError}
          hasLeft={!!left}
          hasRight={!!right}
          outerRightWidth={outerRightWidth}
          innerLeftWidth={innerLeftWidth}
          disabled={disabled}
          readOnly={readOnly}
          data-testid={dataTestId}
          {...inputProps}
          ref={ref}
          autoComplete={autoComplete}
          size={size}
          textAlign={textAlign}
          hasRightSpacing={!!right && !hasRightSpace}
        />
      </Container>
    </Template>
  )
}

export default forwardRef(TextInput)
